import React from "react";
import theme from "theme";
import { Theme, Text, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"terms-and-conditions"} />
		<Helmet>
			<title>
				Frintala Workhouse
			</title>
			<meta name={"description"} content={"Your go-to destination for premium cleaning services"} />
			<meta property={"og:title"} content={"Frintala Workhouse"} />
			<meta property={"og:description"} content={"Your go-to destination for premium cleaning services"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/6799469341a0cf0024a7762d/images/2366071.webp?v=2025-01-28T21:13:17.429Z"} />
			<meta name={"msapplication-TileColor"} content={"#30251F"} />
		</Helmet>
		<Components.Header2 />
		<Section>
			{" "}
			<Text as="h1" font="--headline2">
				Terms and Conditions
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}Our services are intended for personal use only. You agree not to use our services for any unlawful or unauthorized purposes. By using our website, you represent that you are at least 18 years old or have obtained parental consent.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Booking and Payment{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}All bookings are subject to availability. Payment for our services must be made in full prior to or upon completion of the service, unless otherwise agreed. We reserve the right to refuse or cancel any booking at our discretion.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Cancellation Policy{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}Customers may cancel or reschedule bookings at least 24 hours in advance without penalty. Cancellations made less than 24 hours before the scheduled service may be subject to a cancellation fee.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Liability{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}While we strive to provide high-quality services, Frintala Workhouse is not liable for any damages, losses, or injuries arising from the use of our services. Customers are responsible for securing valuables and ensuring safe access to the premises.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Intellectual Property{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}All content on this website, including text, graphics, logos, and images, is the property of Frintala Workhouse and is protected by copyright laws. Unauthorized use of our content is strictly prohibited.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Third-Party Links{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}Our website may include links to third-party websites for your convenience. We are not responsible for the content or practices of these external sites. Accessing these links is at your own risk.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Termination{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}We reserve the right to terminate or suspend access to our services at any time without prior notice if we believe you have violated these terms and conditions.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Changes to Terms{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}Frintala Workhouse may update these terms and conditions from time to time. Any changes will be posted on this page with an updated revision date. Your continued use of our services constitutes acceptance of the updated terms.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Governing Law{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}These terms and conditions are governed by the laws of the jurisdiction in which Frintala Workhouse operates. Any disputes arising from these terms will be resolved in accordance with local laws.{"\n    "}
			</Text>
			{"    "}
			<Text as="h2" font="--headline4">
				{"        "}Contact Us{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				If you have any questions about these terms and conditions, please contact us at info@frintalaworkhouse.com. We are happy to assist you.{"\n    "}
			</Text>
			{"    "}
			<Text as="p" font="--base">
				{"        "}Thank you for choosing Frintala Workhouse. We appreciate your trust in our services.{"\n    "}
			</Text>
		</Section>
		<Components.Footer2 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"615c316435c5c8001f775566"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\n"}
			</style>
		</RawHtml>
	</Theme>;
});